"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    dataGridHeaderClassNames: function() {
        return dataGridHeaderClassNames;
    },
    useDataGridHeaderStyles_unstable: function() {
        return useDataGridHeaderStyles_unstable;
    }
});
const _react = require("@griffel/react");
const _useTableHeaderStylesstyles = require("../TableHeader/useTableHeaderStyles.styles");
const dataGridHeaderClassNames = {
    root: 'fui-DataGridHeader'
};
const useDataGridHeaderStyles_unstable = (state)=>{
    'use no memo';
    (0, _useTableHeaderStylesstyles.useTableHeaderStyles_unstable)(state);
    state.root.className = (0, _react.mergeClasses)(dataGridHeaderClassNames.root, state.root.className);
    return state;
}; //# sourceMappingURL=useDataGridHeaderStyles.styles.js.map
